import { render, staticRenderFns } from "./boardMap.vue?vue&type=template&id=3e66350e&scoped=true&"
import script from "./boardMap.vue?vue&type=script&lang=js&"
export * from "./boardMap.vue?vue&type=script&lang=js&"
import style0 from "./boardMap.vue?vue&type=style&index=0&id=3e66350e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e66350e",
  null
  
)

export default component.exports